import { type CardStatus } from "@/features/card/types/card";

export const getCardStatusTranslationKey = (status: CardStatus) => {
  return `card_${status.toLowerCase()}`;
};
